module.exports = __webpack_public_path__ + "img/deodorizer_set.2cc38959.svg";